module.exports = __webpack_public_path__ + "static/media/armadillo-logo.877a1b14.svg";